<template>
  <div class="participant-assignment light--text" :class="color" @click.stop>
    <template v-if="isAssigned">
      Assigned to <strong class="ml-2">{{ hostName }}</strong>
    </template>
    <template v-else>
      {{ status || 'Unassigned' }}
    </template>

    <span class="pl-2" v-if="isAssigned"> ({{ order }}) </span>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ParticipantAssignment',
  props: {
    status: String,
    order: {},
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
    ...mapGetters('rooms', ['getParticipantJoinInfo']),
    hostName() {
      let host = null;
      if (this.roomInfo.identity === this.status) {
        host = this.roomInfo;
      } else {
        host = this.getParticipantJoinInfo(this.status);
      }

      return host?.name || this.status;
    },
    color() {
      if (!this.status) return 'warning';
      if (this.status === 'rejected') return 'error';
      return 'appMain';
    },
    isAssigned() {
      return this.status && this.status !== 'rejected';
    },
  },
};
</script>

<style lang="less">
.participant-assignment {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  color: #fff;
  padding: 5px 10px;
  border-radius: 0 0 4px 0;
  box-shadow: @base-shadow;
  display: flex;
  align-items: center;
  font-size: 12px;
  user-select: none;
}
</style>
